<template>
  <v-row justify="center" align="center" class="skewed-bg">
    <v-col cols="12" sm="11" md="10" lg="10" style="z-index:1">
      <v-card>
        <v-row justify="center" align="center">
          <v-col cols="11" style="margin-bottom:5%;margin-top:5%">
            <v-container>
              <v-card>
                <v-container>
                  <v-row justify="center" align="center">
                    <v-col align="center" cols="12" class="pb-0">
                      <v-img
                        style="margin-bottom:-7%;margin-top:-7%"
                        width="600"
                        src="@/assets/Mail.png"
                      ></v-img>
                    </v-col>
                    <v-col cols="12" align="center" class>
                      <span class="text_title_1">ลืมรหัสผ่าน</span>
                    </v-col>

                    <v-col cols="11" sm="10" md="6" class="pt-0">
                      <v-form ref="form" @submit.prevent="submit">
                        <v-row justify="center" align="center">
                          <v-col cols="12">
                            <span class="text_body_6">อีเมล</span>
                            <v-text-field
                              v-model="email"
                              outlined
                              dense
                              single-line
                              label="ระบุอีเมลของคุณ"
                              :disabled="loading"
                              :rules="rule_email"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="12" align="right">
                            <v-btn color="primary" large type="submit" :loading="loading">
                              <span class="text_title_4">ตกลง</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      email: "",
      loading: false,
      rule_email: rules.email,
    };
  },
  created() {},
  watch: {},
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        // console.log("submit");
        this.loading = true;
        let data = {
          email: this.email,
          redirectLink: process.env.VUE_APP_LOCALHOST + "reset_password",
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "api/v1/forgetpassword",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data == "send mail success") {
              this.$swal.fire({
                icon: "success",
                title: "ระบบทำการส่ง Link ไปยัง Email สำเร็จ",
                text: "โปรดทำการตรวจสอบ Email",
                showConfirmButton: false,
                timer: 2500,
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
                stopKeydownPropagation: true,
              });
              this.loading = false;
              this.$router.push("/login");
            } else if (response.data == "not success") {
              this.$swal.fire({
                icon: "warning",
                title: "Email ไม่ถูกต้อง",
                text: "โปรดทำการตรวจสอบ Email ใหม่อีกครั้ง",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 2500,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                stopKeydownPropagation: false,
              });
              this.loading = false;
            }
          })
          .catch((err) => {
            // console.log("api reset password sendmail err !!");
          });
      }
    },
  },
};
</script>
<style>
.skewed-bg {
  background: #e9f1fe;
  color: #fff;
  padding: 2em;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  z-index: 0;
}
.skewed-bg::after {
  content: "";
  position: absolute;
  top: 200px;
  left: 0;
  right: 0;
  height: 100%;
  background: #fff;
  transform: skew(0deg, 0deg);
  z-index: 0;
}
</style>
